import React, { useEffect, useState } from 'react';
import { Button, Card, CardMedia, Typography } from '@one-thd/sui-atomic-components';

const ProExtraProductOnly = () => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('pro-extra-product-only.ready'); }, []);

  const [loginUrl, setLoginUrl] = useState('/auth/view/signin?redirect=');
  const [isSignedInUser, setIsSignedInUser] = useState(false);

  useEffect(() => {
    setLoginUrl(`/auth/view/signin?redirect=${window.location.pathname}`);
    setIsSignedInUser(window.THDCustomer?.default?.isLoggedIn);
  }, []);

  return (
    <div className="sui-w-full">
      <div className="sui-flex sui-flex-col">
        <Card className="sui-mb-2">
          <div className="sui-flex sui-flex-col sui-items-start sm:sui-flex-row sm:sui-items-center">
            <CardMedia
              src="https://assets.thdstatic.com/images/v1/Pro-Logo-Steel.svg"
              className="sui-w-20 sm:sui-w-24 sui-h-8 sui-aspect-auto sui-mr-5"
            />
            <div className="sui-overflow-hidden sui-my-4">
              <div className="sui-mb-2">
                <Typography variant="h5">
                  This item available exclusively to verified businesses.
                </Typography>
              </div>
              <Typography variant="body-base">
                To access this item or other exclusive products and business tools,
                call us at <a href="tel:8663333551">866-333-3551</a>. Verified businesses can access these items by
                joining Pro Xtra and logging into their account.
              </Typography>
            </div>
          </div>
        </Card>
        {!isSignedInUser && (
          <div className=" sui-items-center sui-flex sui-flex-col">
            <div className="sui-m-2 sui-text-center">
              <Typography variant="h5">
                Already Have A Pro Xtra Account?
              </Typography>
            </div>
            <div className="sui-w-72">
              <Button href={loginUrl} fullWidth=" true" variant="secondary">
                Login to Purchase
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

ProExtraProductOnly.displayName = 'ProExtraProductOnly';
ProExtraProductOnly.dataModel = {};

export { ProExtraProductOnly };
